<template>
    <div class="body">
        <div class="hello">
            <div class="activity">
                <img src="../assets/Topic@4x.png" alt="">
            </div>
            <p class="activity">Please select your preferred session:</p>
            <!-- <router-link class="activity" to="/hkkf/froms?Session=0"><img src="../assets/TuenMun@4x.png" alt=""></router-link>
            <router-link class="activity" to="/hkkf/froms?Session=1"><img src="../assets/TsuenWan@4x.png" alt=""></router-link> -->
            <!-- <div class="activity"><img src="../assets/TaiPo@4x.png" alt=""></div>
            <div class="activity"><img src="../assets/WanChai@4x.png" alt=""></div> -->
            <!-- <router-link class="activity" to="/hkkf/froms?Session=3"><img src="../assets/WanChai@4x.png" alt=""></router-link> -->
            <!-- <router-link class="activity" to="/hkkf/froms?Session=4"><img src="../assets/ShaTin@4x.png" alt=""></router-link> -->
            <!-- <router-link class="activity" to="/hkkf/froms?Session=5"><img src="../assets/KwunTong@4x.png" alt=""></router-link> -->
            <!-- <router-link class="activity" to="/hkkf/froms?Session=6"><img src="../assets/CWB@4x.png" alt=""></router-link> -->
            <router-link class="activity" to="/hkkf/froms?Session=7"><img src="../assets/MongKok@4x.png" alt=""></router-link>
            <div class="activity">
                <img src="../assets/Agenda@4x.png" alt="">
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'HomePage',
    data() {
        return {
        };
    },
    methods: {
    },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body {
    width: 100%;
    display: flex;
    justify-content: center;
}

.hello {
    max-width: 1040px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: wrap;
}

.activity {
    max-width: 1040px;
    margin-top: 5%;
    font-size: 30px;
    text-align: left;
}
.activity img {
  max-width: 100%; /* 圖片最大寬度為容器寬度的100% */
  max-height: 100%; /* 圖片最大高度為容器高度的100% */
  height: auto; /* 保持圖片的原始寬高比 */
}

.top {
    width: 100%;
    height: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bottom {
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    padding-top: 30%;
    font-size: 40px;
}

.button {
    width: 80%;
    height: 40px;
    background-color: #008b8b;
    border: none;
    color: white;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    cursor: pointer;
    border-radius: 1em;
}

.button:hover {
    background-color: rgba(0, 64, 156, 0.8);
}
</style>
